import { Component, OnInit } from '@angular/core';
import {PortfolioService} from "./portfolio.service";
import { PortfolioTableComponent } from "./portfolio-table/portfolio-table.component";
import { Router, RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/app.materials';
import {FileUploaderComponent} from 'src/app/components/file-uploader/file-uploader.component'
import { CompanyModel } from 'src/app/shared/models/company.model';
import { MatDialog } from '@angular/material/dialog';
import { UploadResultDialogComponent } from 'src/app/components/upload-result-dialog/upload-result-dialog.component';
import { PortfolioModel } from 'src/app/shared/models/portfolio.model';
@Component({
  selector: 'app-portfolio',
  templateUrl: './portfolio.component.html',
  styleUrls: ['./portfolio.component.scss'],
  imports: [PortfolioTableComponent, RouterModule, MaterialModule, FileUploaderComponent],
  standalone: true,
})
export class PortfolioComponent implements OnInit {

  selectedTab = 0;
  isUploading = false;

  lists: any = {
    private: [],
    public: [],
    shared_by_me: [],
    shared_with_me: [],
    tutorials: []
  };

  constructor(
    private service: PortfolioService,
    private router: Router,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.fetchPortfolios();
    this.listenFinished();
  }

  listenFinished() {
    this.service.isPortfolioFinished().subscribe((resp: any) => {
      if (resp && resp.id) {
        this.fetchPortfolios();
      }
    })
  }

  fetchPortfolios() {
    this.service.portfolioFinished.next({});
    this.lists = {
      private: [],
      public: [],
      shared_by_me: [],
      shared_with_me: [],
      tutorials: []
    };
    this.service.getItems().subscribe((resp: any) => {
      if (resp.error) {
        this.service.notificationService.open(resp.error)
      }
      resp = this.service.extractPortfolioDataModels(resp);
      this.lists = resp;

      if (this.lists.shared_by_me && this.lists.shared_by_me.length) {
        this.lists.shared_by_me = this.lists.shared_by_me.map((p: any) => {
          const sharedUsers: string[] = [];
          p.shared_with_users.map((u: any) => {
            sharedUsers.push(u.name);
          });
          p.shared_with_users_concat = sharedUsers.join(', ');
          return p;
        });
      }

      // merge private and shared by me lists
      this.lists.private = [
        ...(this.lists.private ?? []),
        ...(this.lists.shared_by_me ?? [])
      ]
      this.service.portfolioLists = this.lists;

      if (this.service.pendingComputingPortfolioId) {
        this.forcePortfolioStatus(this.service.pendingComputingPortfolioId, 1);
        this.service.pendingComputingPortfolioId = null;
      }
    })
  }

  private forcePortfolioStatus(id: number, status: number) {
    for (const key of Object.keys(this.lists)) {
      const item = (this.lists[key] as any[])?.find(p => p.id === id);
      if (item) {
        item.status = status;
      }
    }
  }

  forkItem(item) {
    this.service.forkItem(item.id).subscribe((resp: any) => {
      if (resp.error) {
        return this.service.notificationService.open(resp.error)
      }
      this.service.notificationService.open('Portfolio copied to your private list.')
      window.location.reload();
    })
  }

  unshareItem(item) {
    this.service.leaveShareItem(item.id)
      .subscribe(resp => {
        this.service.notificationService.open('Share removed');
        this.lists.shared_with_me = this.lists.shared_with_me.filter(p => p.id !== item.id);
      });
  }

handleResponse(resp) {
    let companies = [];
    let notFound = [];
    if (resp.success) {
      if (resp.success.items && resp.success.items.length) {
        companies = resp.success.items.map((i: any) => {
          let weight = resp.success.weights[i.isin];
          i.weight = weight ? weight : 0;
          i.selected = true;
          return new CompanyModel(i);
        })
      }
      notFound = resp.success.not_found || [];
    }
    return {
      companies: companies,
      notFound: notFound
    };
  }

  onNewPortfolio() {
    this.service.clearUploadState();
  }

  onUploadEvent(file) {
    if (!file) {
      return this.service.notificationService.open("Error. Missing file.");
    }
    this.isUploading = true;
    const formData = new FormData();
    formData.append('file', file);
    this.service.uploadCSVFile(formData).subscribe((resp: any) => {
      this.isUploading = false;
      if (resp.error) {
        return this.service.notificationService.open(resp.error);
      }

      const result = this.handleResponse(resp);
      this.service.uploadedCompanies = result.companies;
      this.service.uploadedNotFound = result.notFound;
      
      // Check if there are any not found ISINs
      if (result.notFound && result.notFound.length > 0) {
        // Show dialog with results
        const dialogRef = this.dialog.open(UploadResultDialogComponent, {
          data: {
            successCount: result.companies.length,
            notFound: result.notFound
          },
          maxWidth: '500px',
          disableClose: false
        });

        dialogRef.afterClosed().subscribe((confirmed) => {
          if (confirmed) {
            this.router.navigate(['app/portfolio-create/select']);
          }
        });
      } else {
        // All ISINs found, show success message and navigate
        this.service.notificationService.open(`File uploaded! All ${result.companies.length} companies imported.`);
        this.router.navigate(['app/portfolio-create/select']);
      }
    })
  }
}
